import React, { useContext, useEffect } from 'react';
import { Button, Table, Icon, Label, Container } from 'semantic-ui-react';
import * as XLSX from 'xlsx'
import FttbHourStore from '../../../app/stores/fttbhourStore';
import { observer } from 'mobx-react-lite';
import { RouteComponentProps } from 'react-router';


const FttbHourCreateForm: React.FC<RouteComponentProps> = ({
  match,
  history
}) => {
  const fttbhourStore = useContext(FttbHourStore);
  const {
    createFttbHour,
    submitting,
    importFttbHours,
    fttbhourList,
    clearFttbHour
  } = fttbhourStore;

  useEffect(() => {

    return () => {
      clearFttbHour();
    };
  }, []);

  const handleSubmit = () => {
    createFttbHour(fttbhourList).then(() => history.push(`/financemanagement/fttbhour`));
  };

  const readExcel=(file: any)=> {
    const promise = new Promise((resolve, reject) => {
    const fileReader = new FileReader();
   fileReader.readAsBinaryString(file[0]);

    fileReader.onload = () => {
      // const bufferArray = e.target!.result;
      const bufferArray = fileReader.result;
      const wb = XLSX.read(bufferArray, {type: 'binary'});
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws);

      resolve(data);
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
    });

    promise.then((data) => {
      importFttbHours(data);
    }).catch((error) => console.log(error));
  }
  var i = 0;
  return (
    <Container fluid>
      <Button as="label" htmlFor="file" type="button" color='blue' size='small'>
        <Icon name='file excel' />
        Import
      </Button>
      <input type="file" id="file" accept='.xlsx, .xls, .csv' hidden
        onChange={(e) => {
          const file = e.target.files;
          readExcel(file);
        }} />
        <Button
          loading={submitting}
          floated='right'
          color='green'
          onClick={handleSubmit}
          content='Submit'
        />

      <Table celled>
        <Table.Header>
          <Table.Row>
          <Table.HeaderCell>No.</Table.HeaderCell>
          <Table.HeaderCell>Financial Year</Table.HeaderCell>
          <Table.HeaderCell>Pay Run</Table.HeaderCell>
          <Table.HeaderCell>Date</Table.HeaderCell>
            <Table.HeaderCell>Order No.</Table.HeaderCell>
            <Table.HeaderCell>Hours</Table.HeaderCell>
            <Table.HeaderCell>Code</Table.HeaderCell>
            <Table.HeaderCell>Tech</Table.HeaderCell>
            <Table.HeaderCell>Note</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {fttbhourList.map(fttbhour => {
              i = i + 1;
          return     <Table.Row key={fttbhour.id}>
              <Table.Cell>
                {i}
              </Table.Cell>
              <Table.Cell>{fttbhour.financialYear}</Table.Cell>
              <Table.Cell>{fttbhour.payRun}</Table.Cell>
              <Table.Cell>{fttbhour.date.substr(8,2) + '/' +
               fttbhour.date.substr(5,2) + '/' + fttbhour.date.substr(0,4)}</Table.Cell>
              <Table.Cell>{fttbhour.orderNumber}</Table.Cell>
              <Table.Cell>{fttbhour.hours}</Table.Cell>
              <Table.Cell>{fttbhour.code}</Table.Cell>
              <Table.Cell>{fttbhour.tech}</Table.Cell>
              <Table.Cell>{fttbhour.note}</Table.Cell>
            </Table.Row>;
             })}
        </Table.Body>
      </Table>
      
    </Container>
  );
};

export default observer(FttbHourCreateForm);
